import React, { useMemo, useRef } from 'react'

import { MainMenuFragmentFragment } from '../../../graphql/gatsby'
import { useSanityRoleAndContextBasedContent } from '../../../lib/sanity'
import { LinkRef } from '../Link'
import MenuEntryLink from './MenuEntryLink'

type MainMenuEntries = NonNullable<MainMenuFragmentFragment['mainMenu']>

export interface SubMenuEntryProps {
  menuEntry: NonNullable<MainMenuEntries[number]>
  onClick?: (href?: string) => void
}

const SubMenuEntry: React.FC<SubMenuEntryProps> = React.memo(({ menuEntry, onClick }) => {
  const { shouldDisplayContent } = useSanityRoleAndContextBasedContent()
  const shouldDisplay = useMemo(
    () => shouldDisplayContent(menuEntry),
    [menuEntry, shouldDisplayContent],
  )

  const linkRef = useRef<LinkRef>(null)

  if (!shouldDisplay) {
    return null
  }

  return (
    <MenuEntryLink
      data-content={menuEntry.name}
      link={menuEntry.link}
      ref={linkRef}
      onClick={() => onClick?.(linkRef.current?.href)}
      className="relative after:content-[attr(data-content)] after:block after:font-medium after:h-0 after:invisible after:overflow-hidden"
    >
      {menuEntry.name}
    </MenuEntryLink>
  )
})

SubMenuEntry.displayName = 'SubMenuEntry'

export default SubMenuEntry
